import axios from 'axios';

let pollTimer = null;
let redirectPopup = null;
let features = {
    width: 400,
    height: 599,
    left: 0,
    top: 0,
};
const appHost = document.location.origin;
const auth0Redirect = '/auth0/login';

const calcWindowFeatures = () => {
  const docElem = document.documentElement;
  const screen = window.screen;
  const width = window.innerWidth
    ? window.innerWidth
    : (docElem.clientWidth ? docElem.clientWidth : screen.width);
  const height = window.innerHeight
    ? window.innerHeight
    : (docElem.clientHeight ? docElem.clientHeight : screen.height);

  features.left = width / 2 - features.width / 2 + window.screenLeft;
  features.top = height / 2 - features.height / 2 + window.screenTop;

  return `top=${features.top},left=${features.left},height=${features.height},width=${features.width}`;
}; 

const checkRedirectedHost = (location) => {
  const url = new URL(appHost);
  return location?.hostname === url.hostname;
};

const verifyRedirectAndComplete = () => {
  const location = redirectPopup.location;
  if (checkRedirectedHost(location)) {
      redirectPopup.close();
      const opener = redirectPopup.opener;
      opener.location.reload();
      window.clearInterval(pollTimer);
  }
};

const ensureRequest = (url, callback) => {
  const controller = new AbortController();
  axios.get(`${url}`, 
    {
      signal: controller.signal,
    })
  .then(callback())
  .catch(
    (error) => {
      if (error.response) {
        // eslint-disable-next-line no-console
        console.error(`Can't open redirect popup due to error accessing 
          ${url}: ${error.response.data}`);
      }
    })
  .then(
    () => {
      controller.abort();
    });
}

const AuthPopup = {
  openAuth0DOMPopup: (event) => {
    event.preventDefault();
    if (redirectPopup === null || redirectPopup.closed) {
      ensureRequest(`${appHost}${auth0Redirect}`, 
        () => {
          redirectPopup = window.open(
            `${appHost}${auth0Redirect}`,
            'Sign In', 
            calcWindowFeatures());
          if (redirectPopup) {
            pollTimer = window.setInterval(verifyRedirectAndComplete, 450);
          }
        });

    } else {
      redirectPopup.focus();
    }
  },
};

export default AuthPopup;
